__webpack_require__.p = "https://cdn.n-tv.de/sport/0.92.0/_next/";